// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.inv_certificate_target_enum */
var InvCertificateTargetEnum;
(function (InvCertificateTargetEnum) {
    InvCertificateTargetEnum["supplier"] = "supplier";
    InvCertificateTargetEnum["product"] = "product";
    InvCertificateTargetEnum["item"] = "item";
})(InvCertificateTargetEnum || (InvCertificateTargetEnum = {}));
;
export default InvCertificateTargetEnum;
/** Zod schema for inv_certificate_target_enum */
export const invCertificateTargetEnum = z.nativeEnum(InvCertificateTargetEnum);
//# sourceMappingURL=InvCertificateTargetEnum.js.map